module.exports = __webpack_public_path__ + "img/use_selected.ce49dc14.svg";